module.exports = __webpack_public_path__ + "static/media/Epigenetics.d6bd6ba7.svg";